import ViewController from "./class.ViewController";

const discussCaption = "Start topic about this lesson.";
const discussionsCaption = "View discussions about this lesson.";

export default class TransporterCmty extends ViewController {
	constructor(options) {
		super(options);

		this.onCmtyStartTopic = this.mainController.onCmtyStartTopic;
		this.onCmtyOpenDiscussions = this.mainController.onCmtyOpenDiscussions;

		if (AoPS && AoPS.Feed) {
			// build the discuss icon
			this.$discussIcon = $(
				`<div class="menu-icon discuss-new-icon"><span class="aops-font">V</span></div>`
			)
				.attr("title", discussCaption)
				.appendTo(this.$el)
				.click(() => {
					if (_.isFunction(this.onCmtyStartTopic)) {
						this.onCmtyStartTopic();
					}
				});

			// build the discussions icon
			this.$discussionsIcon = $(
				`<div class="menu-icon discussions-icon"><span class="aops-font">t</span></div>`
			)
				.attr("title", discussionsCaption)
				.appendTo(this.$el)
				.click(() => {
					if (_.isFunction(this.onCmtyOpenDiscussions)) {
						this.onCmtyOpenDiscussions();
					}
				});

			if (AoPS.Ecole && AoPS.Ecole.Utils && AoPS.Ecole.Utils.CreateTooltip) {
				AoPS.Ecole.Utils.CreateTooltip(this.$discussIcon, discussCaption);
				AoPS.Ecole.Utils.CreateTooltip(
					this.$discussionsIcon,
					discussionsCaption
				);
			}
		}
	}
}
